import "./footer.css";
const Footer = () => {
  return (
    <>
      <footer>
        <p>Copyright &copy; Easy Coding Tutorial</p>
      </footer>
    </>
  );
};
export default Footer;
